import * as React from "react";

export interface IDailyListNoEventProps {
    noEventThisDayText: string;
}

export const DailyListNoEvent = (props: IDailyListNoEventProps) => {
    return (
        <tr className="CAL-V-LV-list" >
            <td className="CAL-V-LV-name" colSpan={3}>
                <a href="#!">{props.noEventThisDayText}</a>
            </td>
         </tr>
    );
};
